module.exports = {
    breaklinesUnsafe(text) {
        if (text && typeof text === 'string') {
            text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
        }

        return text;
    },
};
